import { keepPreviousData } from '@tanstack/react-query';
import { PortfolioTabs } from '@unistocks/features/portfolios/components/portfolio-details/portfolio-tabs';
import { usePortfolioHistory } from '@unistocks/features/portfolios/hooks/use-portfolio-history';
import { PortfolioDto } from '@unistocks/proxy/axios-client';
import { startOfYear, today, yesterday } from '@unistocks/shared/utils/util';
import { DateRange, Filter } from '@unistocks/types';
import { useState } from 'react';

export type PortfolioDetailsProps = {
  portfolio: PortfolioDto;
};

export const PortfolioDetails: React.FC<PortfolioDetailsProps> = ({ portfolio }) => {
  const { id } = portfolio;
  const [sectionFilter, setSectionFilter] = useState<Filter<string>>({
    type: 'exclude',
    values: []
  });
  const [assetFilter, setAssetFilter] = useState<Filter<string>>({ type: 'exclude', values: [] });
  const [[startDate, endDate], setDateRange] = useState<DateRange>([startOfYear(), today()]);

  const { data: portfolioHistory, isPending: isLoadingPortfolioHistory } = usePortfolioHistory(
    id,
    startDate,
    endDate,
    {
      placeholderData: keepPreviousData
    }
  );

  const { data: todaysChange, isFetching: isLoadingTodaysChange } = usePortfolioHistory(
    id,
    yesterday(),
    undefined,
    {
      placeholderData: keepPreviousData
    }
  );

  return (
    <PortfolioTabs
      portfolio={portfolio}
      portfolioHistory={portfolioHistory}
      isLoadingPortfolioHistory={isLoadingPortfolioHistory}
      todaysChange={todaysChange}
      todaysChangeLoading={isLoadingTodaysChange}
      assetFilter={assetFilter}
      setAssetFilter={setAssetFilter}
      sectionFilter={sectionFilter}
      setSectionFilter={setSectionFilter}
      setDateRange={setDateRange}
    />
  );
};

PortfolioDetails.displayName = 'PortfolioDetails';
